import React from 'react';
import CollectionFetch from "@web/ui/containers/CollectionFetch";
import DashboardFullRow from "./DashboardFullRow";
import AppStore from "@web/page/AppStore";

function AppsContent() {
  return <DashboardFullRow>
    <section style={{width: "100%", margin: "0 auto"}}>
      <CollectionFetch
        collectionId="apps"
        activeKey="published"
        component={AppStore}
      />
    </section>
  </DashboardFullRow>
}

export default AppsContent;
